export default __webpack_public_path__ + "static/media/settings_room_device_speaker.30afd170.svg";